
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useI18n } from '../i18n/i18n';

interface CurrencySelectorProps {
  value: string;
  onChange: (value: string) => void;
}

const CurrencySelector = ({ value, onChange }: CurrencySelectorProps) => {
  const { t } = useI18n();

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[100px]">
        <SelectValue>
          {value === "EUR" ? "EUR (€)" : value === "USD" ? "USD ($)" : value}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="EUR">EUR (€)</SelectItem>
        <SelectItem value="USD">USD ($)</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default CurrencySelector;
